import { Component, DoCheck, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IExame } from 'src/app/shared/interfaces/exames/iexame';
import { ModalService } from 'src/app/shared/services/modal.service';
import { exameActions } from 'src/app/store/exame/exame.actions';
import { selectExamByID, selectExamLoading, selectExamState } from 'src/app/store/exame/exame.selectors';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista, selectUnitActiveList, selectUnitState } from 'src/app/store/unidade/unidade.selectors';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Component({
  selector: 'app-exame-form',
  templateUrl: './exame-form.component.html',
  styleUrls: ['./exame-form.component.scss']
})
export class ExameFormComponent implements OnInit {
  setAgeGroupPristineClass: boolean = false
  allowNext: boolean = false
  isMaxValid: boolean = true
  isMinValid: boolean = true
  isScheduleValid: boolean = false
  serviceCodeFilled: boolean = true
  allowSubmit: boolean = false
  isDay0Valid: boolean = true
  isDay1Valid: boolean = true
  isDay2Valid: boolean = true
  isDay3Valid: boolean = true
  isDay4Valid: boolean = true
  isDay5Valid: boolean = true
  isDay6Valid: boolean = true

  exceptionsDaysArray: any
  scheduleArray!: Array<any>
  unidadeFiltrada: any[] = []
  listUnit = [];
  deliveryTime: Array<{ label: string, value: number }> = []
  serviceTime: Array<{ label: string, value: number }> = []
  ageGroup: Array<number> = [null as any, null as any]

  unidadeLista$ = this.store.select(selectUnitActiveList);
  unitsFromAPI$ = this.store.select(selectUnidadeLista)
  examByID$ = this.store.select(selectExamByID)
  isLoading$ = this.store.select(selectExamLoading)
  unitState$ = this.store.select(selectUnitState)
  selectExamState$ = this.store.select(selectExamState)
  unitId = localStorage.getItem('unitId')

  form = this.fb.group({
    unit: ['', [Validators.required]],
    flagIssueInvoice: false,

    name: ['', [Validators.required]],
    units: [null as any],
    deliveryTime: [null as any, [Validators.required]],
    serviceTime: [0],
    value: [null as any, [Validators.required, Validators.min(1)]],
    ageGroup: [{ minAge: 0 as any, maxAge: 100 as any }],
    description: [''],
    guidelines: [''],

    serviceCode: this.fb.array([]),

    scheduleRelatedUnit: [null as any],


    weekSeg: [{
      switch: false,
      weekDay: 1,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekTer: [{
      switch: false,
      weekDay: 2,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekQua: [{
      switch: false,
      weekDay: 3,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekQui: [{
      switch: false,
      weekDay: 4,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekSex: [{
      switch: false,
      weekDay: 5,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekSab: [{
      switch: false,
      weekDay: 6,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],
    weekDom: [{
      switch: false,
      weekDay: 0,
      periods: [
        {
          horarioIni: "",
          horarioFim: ""
        }
      ]
    }],

    exceptions: this.fb.array([]),

  })

  get serviceCode() {
    return this.form.controls["serviceCode"] as FormArray;
  }

  get exceptions() {
    return this.form.controls["exceptions"] as FormArray;
  }

  get units() {
    return this.form.get('units')?.value?.map((unit: any) => this.listUnit.find((u: any) => u['@id'] === unit));
  }

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
    private store: Store,
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private notify: NotifyService,
  ) { }

  ngOnInit(): void {

    this.selectExamState$.subscribe(res => {
      //console.log('state: ', res)
      if((res.action == 'edit' || res.action == 'save') && res.type == 'success'){
        this.ref.close()
        this.store.dispatch(exameActions.loadExame())
      }
    })


    //this.serviceCodeFilled = true

    this.unitsFromAPI$.subscribe((res: any) => {
      this.listUnit = res.filter((item: any) => item.isActive == true);
      return this.unidadeFiltrada = res.filter((item: any) => item.isActive == true)
    });

    if (this.config.data?.id) {

      const data = this.config.data
      console.log(data);
      //console.log('data: ', data)

      this.form.patchValue({
        flagIssueInvoice: data.flagIssueInvoice,
        name: data.name,
        //units: data.units.map((unit: any) => unit['@id']),
        //unit: data.unit,
        deliveryTime: data.deliveryTime,
        serviceTime: data.serviceTime,
        value: data.value,
        ageGroup: ({
          maxAge: data.ageGroup.maxAge,
          minAge: data.ageGroup.minAge
        }),
        description: data.description,
        guidelines: data.guideline,
        unit: data?.unit['@id']
      })

      this.ageGroup = [data.ageGroup.minAge, data.ageGroup.maxAge]

      if (data.serviceCodes?.length > 0) {
        data.serviceCodes.forEach(
          (serviceCode: any) => {
            const serviceCodeForm = this.fb.group({
              code: serviceCode.code,
              units: [serviceCode.units]
            });

            this.serviceCode.push(serviceCodeForm)
          }
        )
        //this.validateServiceCode()
      } else {
        this.addServiceCode()
      }

      //this.patchExamSchedule(data.examSchedules[0])
      this.allowNext = true
      this.setAgeGroupPristineClass = false

    } else {
      this.addServiceCode()
      this.setAgeGroupPristineClass = true
    }

    //console.log('form', this.form.value)

    this.fillTempoAtendimento()
    this.fillTempoEntrega()

    this.store.dispatch(loadUnidade());

  }

  onSubmit() {
    const form = this.form.value;

    console.log(form.unit)

    let req: IExame | any = {
      active: true,
      flagIssueInvoice: form.flagIssueInvoice as boolean,
      name: form.name as string,
      //unitId: this.unitId,
      unit: form.unit,
      deliveryTime: form.deliveryTime,
      serviceTime: form.serviceTime,
      value: form.value,
      ageGroup: {
        maxAge: form.ageGroup?.maxAge,
        minAge: form.ageGroup?.minAge
      },
      description: form.description as string,
      guideline: form.guidelines as string,
      serviceCodes: this.serviceCode.value[0].code == '' ? [] : this.validateLastServiceCode(),
      //examSchedules: [this.createSchedule()],
    }

    //console.log('req ', req)
    //console.log('form ', this.form.value)

    if (this.config.data?.id) {
      this.store.dispatch(exameActions.editExame({ exame: req, id: this.config.data?.id }))
    } else {
      this.store.dispatch(exameActions.saveExame({ exame: req }))
    }

    //this.ref.close()
  }

  validateLastServiceCode() {
    let index = this.serviceCode.value.length - 1
    if (this.serviceCode.value[index].code == '') {
      this.serviceCode.removeAt(index)
    }

    return this.serviceCode.value
  }

  validateChar(event: KeyboardEvent) {
    const regex = /^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ\s]+$/;

    const key = event.key;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  validateChildComponent(event: any, dayNumber: number) {
    switch (dayNumber) {
      case 0:
        this.isDay0Valid = event;
        break;
      case 1:
        this.isDay1Valid = event;
        break;
      case 2:
        this.isDay2Valid = event;
        break;
      case 3:
        this.isDay3Valid = event;
        break;
      case 4:
        this.isDay4Valid = event;
        break;
      case 5:
        this.isDay5Valid = event;
        break;
      case 6:
        this.isDay6Valid = event;
        break;
    }

    this.validateAllSchedule()
  }

  validateAllSchedule() {
    this.exceptionsDaysArray = []

    let dom = this.form.get('weekDom')?.value?.switch
    let seg = this.form.get('weekSeg')?.value?.switch
    let ter = this.form.get('weekTer')?.value?.switch
    let qua = this.form.get('weekQua')?.value?.switch
    let qui = this.form.get('weekQui')?.value?.switch
    let sex = this.form.get('weekSex')?.value?.switch
    let sab = this.form.get('weekSab')?.value?.switch

    if (dom || seg || ter || qua || qui || sex || sab) {
      if (
        this.isDay0Valid &&
        this.isDay1Valid &&
        this.isDay2Valid &&
        this.isDay3Valid &&
        this.isDay4Valid &&
        this.isDay5Valid &&
        this.isDay6Valid
      ) {
        this.allowSubmit = true
        this.isScheduleValid = true

      } else {
        this.isScheduleValid = false
        this.allowSubmit = false

      }
    } else {
      this.isScheduleValid = false
      this.allowSubmit = false

    }

    if (this.exceptions.length > 0) {
      this.validateException()
    }

    if (dom) {
      this.exceptionsDaysArray.push({ value: 0, name: 'Domingo' })
    }
    if (seg) {
      this.exceptionsDaysArray.push({ value: 1, name: 'Segunda-feira' })
    }

    if (ter) {
      this.exceptionsDaysArray.push({ value: 2, name: 'Terça-feira' })
    }

    if (qua) {
      this.exceptionsDaysArray.push({ value: 3, name: 'Quarta-feira' })
    }

    if (qui) {
      this.exceptionsDaysArray.push({ value: 4, name: 'Quinta-feira' })
    }
    if (sex) {
      this.exceptionsDaysArray.push({ value: 5, name: 'Sexta-feira' })
    }
    if (sab) {
      this.exceptionsDaysArray.push({ value: 6, name: 'Sábado' })
    }
  }

  validateSelectWeekPeriod(periods: any) {
    let isValid: boolean = true
    for (let period of periods) {
      if (
        (period.horarioIni == null) ||
        (period.horarioFim == null) ||
        (period.horarioIni == '') ||
        (period.horarioFim == '') ||
        (period.horarioIni == '00:00' && period.horarioFim == '00:00') ||
        !this.compareTimes(period.horarioIni, period.horarioFim)
      ) {
        isValid = false
        break;
      }
    }

    return isValid
  }

  validateException() {
    if (this.isScheduleValid == true) {
      if (this.exceptions.value.length == 0) {
        this.allowSubmit = true
        return
      }

      for (let item of this.exceptions.value) {
        if (item.dayOfTheWeek != null) {
          this.allowSubmit = this.compareTimes(item.startTime, item.endTime)

          if (!this.compareTimes(item.startTime, item.endTime)) {
            break;
          }
        } else {
          this.allowSubmit = false
          break;
        }
      }
    }
  }

  removeException(event: number) {
    let oldExceptions = this.exceptions.value

    for (let [index, item] of oldExceptions.entries()) {
      if (item.dayOfTheWeek == event) {
        this.exceptions.removeAt(index)
      }
    }

  }

  getUnitById(unitId: string): any {
    return this.listUnit.find((unit: any) => unit['@id'] == unitId)
  }

  getDayOfWeek(value: number) {
    switch (value) {
      case 0:
        return 'Dom'
      case 1:
        return 'Seg';
      case 2:
        return 'Ter';
      case 3:
        return 'Qua';
      case 4:
        return 'Qui';
      case 5:
        return 'Sex';
      case 6:
        return 'Sáb';
      default:
        return '';
    }
  }

  //createPeriods(examSchedule: any, index: number) {
  createPeriods(timetables: any) {
    let period: any[] = []

    timetables?.forEach(
      (timeTable: any) => {
        period.push(
          {
            horarioIni: timeTable.startTime,
            horarioFim: timeTable.endTime
          }
        )
      }
    )

    return period
  }

  createSchedule() {
    let schedule: { unit: any, schedules: any[], exceptions: any }
    let schedulesActive: any[] = []

    if (this.form.value.weekDom?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekDom?.switch,
          dayOfTheWeek: 0,
          timetables: this.createExamTimetable(0)
        }
      )
    }

    if (this.form.value.weekSeg?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekSeg?.switch,
          dayOfTheWeek: 1,
          timetables: this.createExamTimetable(1)
        }
      )
    }

    if (this.form.value.weekTer?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekTer?.switch,
          dayOfTheWeek: 2,
          timetables: this.createExamTimetable(2)
        }
      )
    }

    if (this.form.value.weekQua?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekQua?.switch,
          dayOfTheWeek: 3,
          timetables: this.createExamTimetable(3)
        }
      )
    }

    if (this.form.value.weekQui?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekQui?.switch,
          dayOfTheWeek: 4,
          timetables: this.createExamTimetable(4)
        }
      )
    }

    if (this.form.value.weekSex?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekSex?.switch,
          dayOfTheWeek: 5,
          timetables: this.createExamTimetable(5)
        },
      )
    }

    if (this.form.value.weekSab?.switch) {
      schedulesActive.push(
        {
          active: this.form.value.weekSab?.switch,
          dayOfTheWeek: 6,
          timetables: this.createExamTimetable(6)
        }
      )
    }

    schedule = {
      unit: `/api/units/${this.unitId}`,
      schedules: schedulesActive,
      //[

      // {
      //   active: this.form.value.weekDom?.switch,
      //   dayOfTheWeek: 0,
      //   timetables: this.createExamTimetable(0)
      // },
      // {
      //   active: this.form.value.weekSeg?.switch,
      //   dayOfTheWeek: 1,
      //   timetables: this.createExamTimetable(1)
      // },
      // {
      //   active: this.form.value.weekTer?.switch,
      //   dayOfTheWeek: 2,
      //   timetables: this.createExamTimetable(2)
      // },
      // {
      //   active: this.form.value.weekQua?.switch,
      //   dayOfTheWeek: 3,
      //   timetables: this.createExamTimetable(3)
      // },
      // {
      //   active: this.form.value.weekQui?.switch,
      //   dayOfTheWeek: 4,
      //   timetables: this.createExamTimetable(4)
      // },
      // {
      //   active: this.form.value.weekSex?.switch,
      //   dayOfTheWeek: 5,
      //   timetables: this.createExamTimetable(5)
      // },
      // {
      //   active: this.form.value.weekSab?.switch,
      //   dayOfTheWeek: 6,
      //   timetables: this.createExamTimetable(6)
      // }

      //],
      exceptions: this.form.value.exceptions
    }

    return schedule
  }

  createExamTimetable(weekDay: number) {
    let timeTable: Array<any> = []

    switch (weekDay) {
      case 0:
        this.form.value.weekDom?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 1:
        this.form.value.weekSeg?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 2:
        this.form.value.weekTer?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 3:
        this.form.value.weekQua?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 4:
        this.form.value.weekQui?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 5:
        this.form.value.weekSex?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
      case 6:
        this.form.value.weekSab?.periods.forEach(
          (period: any) => {
            timeTable.push(
              {
                startTime: period.horarioIni,
                endTime: period.horarioFim
              }
            )
          }
        )
        break;
    }

    return timeTable


  }

  patchFormAgeGroup() {
    const form = this.form
    form.patchValue({

      ageGroup: {
        minAge: this.ageGroup[0],
        maxAge: this.ageGroup[1]
      }
    })

  }

  patchExamSchedule(schedule: any) {

    const data = this.config.data

    this.form.controls.weekDom.reset()
    this.form.controls.weekSeg.reset()
    this.form.controls.weekTer.reset()
    this.form.controls.weekQua.reset()
    this.form.controls.weekQui.reset()
    this.form.controls.weekSex.reset()
    this.form.controls.weekSab.reset()

    schedule.schedules?.forEach((element: any) => {
      if (element.dayOfTheWeek == 0) {
        this.form.patchValue({
          weekDom: {
            switch: element.active,
            weekDay: 0,
            periods: this.createPeriods(element.timetables)
          }
        })
      }

      if (element.dayOfTheWeek == 1) {
        this.form.patchValue({
          weekSeg: {
            switch: element.active,
            weekDay: 1,
            periods: this.createPeriods(element.timetables)
          }
        })
      }

      if (element.dayOfTheWeek == 2) {
        this.form.patchValue({
          weekTer: {
            switch: element.active,
            weekDay: 2,
            periods: this.createPeriods(element.timetables)
          },
        })
      }

      if (element.dayOfTheWeek == 3) {
        this.form.patchValue({
          weekQua: {
            switch: element.active,
            weekDay: 3,
            periods: this.createPeriods(element.timetables)
          },
        })
      }

      if (element.dayOfTheWeek == 4) {
        this.form.patchValue({
          weekQui: {
            switch: element.active,
            weekDay: 4,
            periods: this.createPeriods(element.timetables)
          },
        })
      }

      if (element.dayOfTheWeek == 5) {
        this.form.patchValue({
          weekSex: {
            switch: element.active,
            weekDay: 5,
            periods: this.createPeriods(element.timetables)
          },
        })
      }

      if (element.dayOfTheWeek == 6) {
        this.form.patchValue({
          weekSab: {
            switch: element.active,
            weekDay: 6,
            periods: this.createPeriods(element.timetables)
          }
        })
      }
    })



    //this.form.patchValue({

    //scheduleRelatedUnit: schedule.unit,

    // weekDom: {
    //   switch: schedule.schedules[0].active,
    //   weekDay: 0,
    //   periods: this.createPeriods(schedule.schedules, 0)
    // },
    // weekSeg: {
    //   switch: schedule.schedules[1].active,
    //   weekDay: 1,
    //   periods: this.createPeriods(schedule.schedules, 1)
    // },
    // weekTer: {
    //   switch: schedule.schedules[2].active,
    //   weekDay: 2,
    //   periods: this.createPeriods(schedule.schedules, 2)
    // },
    // weekQua: {
    //   switch: schedule.schedules[3].active,
    //   weekDay: 3,
    //   periods: this.createPeriods(schedule.schedules, 3)
    // },
    // weekQui: {
    //   switch: schedule.schedules[4].active,
    //   weekDay: 4,
    //   periods: this.createPeriods(schedule.schedules, 4)
    // },
    // weekSex: {
    //   switch: schedule.schedules[5].active,
    //   weekDay: 5,
    //   periods: this.createPeriods(schedule.schedules, 5)
    // },
    // weekSab: {
    //   switch: schedule.schedules[6].active,
    //   weekDay: 6,
    //   periods: this.createPeriods(schedule.schedules, 6)
    // }
    //})

    if (schedule.exceptions?.length > 0) {
      this.exceptions.clear()

      schedule.exceptions.forEach(
        (element: any) => {
          this.exceptions.push(this.fb.group({
            dayOfTheWeek: element.dayOfTheWeek,
            startTime: element.startTime,
            endTime: element.endTime
          }))

        }
      )

      //this.validateException()
    } else {
      this.exceptions.clear()
    }



  }

  changeAdicionarExcecao() {
    this.addExceptions()
  }

  addServiceCode() {

    for (let item of this.serviceCode.value) {
      if (item.code == '') {
        this.notify.emitError('Código de serviço vazio')
        return;

      }
    }

    const serviceCodeForm = this.fb.group({
      code: [''],
      units: [[`/api/units/${this.unitId}`]]
    })

    this.serviceCode.push(serviceCodeForm)
    //this.validateServiceCode()

  }

  addExceptions() {
    const exceptionsForm = this.fb.group({
      dayOfTheWeek: [null, Validators.required],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required]
    })

    this.exceptions.push(exceptionsForm)

    this.validateException()
  }

  deleteServiceCode(index: number) {

    if (index == 0 && this.serviceCode.value.length == 1) {
      this.serviceCode.removeAt(index)
      this.addServiceCode()
      this.form.value.flagIssueInvoice = false
    } else {
      this.serviceCode.removeAt(index)
    }

    //this.validateServiceCode()
  }

  deleteExceptions(index: number) {
    this.exceptions.removeAt(index)

    this.validateException()

  }

  updateFaixaEtaria() {

    if (Number(this.ageGroup[0]) > 100) {
      //this.notify.emitError('A Idade Máxima é de 100 anos');
      this.ageGroup = [100, Number(this.ageGroup[1])];
    } if (Number(this.ageGroup[1]) > 100) {
      //this.notify.emitError('A Idade Máxima é de 100 anos');
      this.ageGroup = [Number(this.ageGroup[0]), 100];
    } else {
      this.ageGroup = [Number(this.ageGroup[0]), Number(this.ageGroup[1])];
    }

    if (Number(this.ageGroup[1]) == 0) {
      this.isMaxValid = false
      this.isMinValid = true

      this.allowNext = false
      //return this.notify.emitError('A Idade Máxima deve ser maior que zero');
    } else if (Number(this.ageGroup[1]) <= Number(this.ageGroup[0])) {
      this.isMaxValid = false
      this.isMinValid = true

      this.allowNext = false
      //return this.notify.emitError('A Idade Máxima deve ser maior que a Idade Mínima');
    } else {
      this.isMaxValid = true
      this.isMinValid = true
      this.allowNext = true
      //return this.notify.emitSuccess('Faixa Etária Válida');
    }


    // clearTimeout(this.//)

    // this.// = setTimeout(
    //   () => {

    //     if (Number(this.ageGroup[0]) > 100) {
    //       //this.notify.emitError('A Idade Máxima é de 100 anos');
    //       this.ageGroup = [100, Number(this.ageGroup[1])];
    //     } if (Number(this.ageGroup[1]) > 100) {
    //       //this.notify.emitError('A Idade Máxima é de 100 anos');
    //       this.ageGroup = [Number(this.ageGroup[0]), 100];
    //     } else {
    //       this.ageGroup = [Number(this.ageGroup[0]), Number(this.ageGroup[1])];
    //     }

    //     if (Number(this.ageGroup[1]) == 0) {
    //       this.isMaxValid = false
    //       this.isMinValid = true

    //       this.allowNext = false
    //       //return this.notify.emitError('A Idade Máxima deve ser maior que zero');
    //     } else if (Number(this.ageGroup[1]) <= Number(this.ageGroup[0])) {
    //       this.isMaxValid = false
    //       this.isMinValid = true

    //       this.allowNext = false
    //       //return this.notify.emitError('A Idade Máxima deve ser maior que a Idade Mínima');
    //     } else {
    //       this.isMaxValid = true
    //       this.isMinValid = true
    //       this.allowNext = true
    //       //return this.notify.emitSuccess('Faixa Etária Válida');
    //     }

    //   }, 500
    // )

  }

  onActiveIndexChanged(index: number): void {
    if (this.modalService.action == 'cadastrar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Cadastro de Exames');
          break;
        case 1:
          //this.showEditTimeSchedule ? this.modalService.changeHeader('Lista de Horários') :
          this.modalService.changeHeader('Agenda e Horários');
          break;
      }
    } else if (this.modalService.action == 'editar') {
      switch (index) {
        case 0:
          this.modalService.changeHeader('Editar Exame');
          break;
        case 1:
          //this.showEditTimeSchedule ? this.modalService.changeHeader('Lista de Horários') :
          this.modalService.changeHeader('Editar Agenda e Horários');
          break;
      }
    }

    // if (this.config.data?.id && index == 1) {

    //   //this.loadingSchedule = true

    //   // this.store.dispatch(exameActions.loadExameByID({ id: this.config.data.id }))

    //   // this.examByID$.subscribe({
    //   //   next: (res: any) => {
    //   //     if (res != null) {
    //   //       this.scheduleArray = res.examSchedules

    //   //       let setScheduleArray: any = []
    //   //       let selectedUnits = this.form.value.units

    //   //       selectedUnits.forEach((element: any) => {

    //   //         for (let schedule of this.scheduleArray) {
    //   //           if (element == schedule.unit) {
    //   //             setScheduleArray?.push(schedule);
    //   //             break;
    //   //           }
    //   //         }

    //   //       })

    //   //       this.scheduleArray = setScheduleArray

    //   //       if (this.scheduleArray?.length > 0) {

    //   //         this.showEditTimeSchedule = true
    //   //       } else {

    //   //         this.showEditTimeSchedule = false
    //   //       }
    //   //       //this.loadingSchedule = false

    //   //     }

    //   //   }

    //   // })

    // }

  }

  compareTimes(first: string, second: string) {

    if (first == null || second == null) {
      return false
    }

    const [hour1, minutes1] = first.split(':').map(Number)
    const [hour2, minutes2] = second.split(':').map(Number)

    if (hour2 > hour1) {
      return true
    } else if (hour2 == hour1 && minutes2 > minutes1) {
      return true
    } else { return false }

  }

  /* mock */

  fillTempoAtendimento() {

    for (let tempo = 5; tempo <= 180; tempo += 5) {

      this.serviceTime.push({ label: tempo + ' minutos', value: tempo })

    }

  }

  fillTempoEntrega() {
    for (let dias = 1; dias <= 30; dias += 1) {

      dias == 1 ?
        this.deliveryTime.push({ label: dias + ' dia', value: dias }) :
        this.deliveryTime.push({ label: dias + ' dias', value: dias })

    }

  }

  weekDays: Array<any> = [
    { nome: 'Segunda-Feira', value: 1 },
    { nome: 'Terça-Feira', value: 2 },
    { nome: 'Quarta-Feira', value: 3 },
    { nome: 'Quinta-Feira', value: 4 },
    { nome: 'Sexta-Feira', value: 5 },
    { nome: 'Sábado', value: 6 },
    { nome: 'Domingo', value: 0 },
  ]

  // validateSchedule() {

  //   let dom = this.form.get('weekDom')?.value
  //   let seg = this.form.get('weekSeg')?.value
  //   let ter = this.form.get('weekTer')?.value
  //   let qua = this.form.get('weekQua')?.value
  //   let qui = this.form.get('weekQui')?.value
  //   let sex = this.form.get('weekSex')?.value
  //   let sab = this.form.get('weekSab')?.value
  //   let selectedUnit = this.form.get('scheduleRelatedUnit')?.value

  //   let switchTrueItens: Array<{ value: number, name: string, active: boolean }> = []


  //   if (dom?.switch == true) {
  //     switchTrueItens.push({ value: 0, name: 'Domingo', active: this.validateSelectWeekPeriod(dom.periods) })
  //   }

  //   if (seg?.switch == true) {
  //     switchTrueItens.push({ value: 1, name: 'Segunda-Feira', active: this.validateSelectWeekPeriod(seg.periods) })
  //   }

  //   if (ter?.switch == true) {
  //     switchTrueItens.push({ value: 2, name: 'Terça-Feira', active: this.validateSelectWeekPeriod(ter.periods) })
  //   }

  //   if (qua?.switch == true) {
  //     switchTrueItens.push({ value: 3, name: 'Quarta-Feira', active: this.validateSelectWeekPeriod(qua.periods) })
  //   }

  //   if (qui?.switch == true) {
  //     switchTrueItens.push({ value: 4, name: 'Quinta-Feira', active: this.validateSelectWeekPeriod(qui.periods) })
  //   }

  //   if (sex?.switch == true) {
  //     switchTrueItens.push({ value: 5, name: 'Sexta-Feira', active: this.validateSelectWeekPeriod(sex.periods) })
  //   }

  //   if (sab?.switch == true) {
  //     switchTrueItens.push({ value: 6, name: 'Sábado', active: this.validateSelectWeekPeriod(sab.periods) })
  //   }



  //   if (switchTrueItens.length > 0) {
  //     //this.allowSave = true

  //     this.exceptionsDaysArray = switchTrueItens

  //     for (let item of switchTrueItens) {
  //       if (!item.active) {
  //         this.isScheduleValid = false
  //         this.allowSave = false
  //         break;
  //       } else {

  //         this.isScheduleValid = true

  //         if (this.exceptions.length > 0) {
  //           if (this.isExceptionValid) {
  //             this.allowSave = true
  //           } else {
  //             this.allowSave = false
  //           }
  //         } else {
  //           this.allowSave = true
  //         }

  //       }
  //     }

  //   } else {
  //     this.isScheduleValid = false
  //     this.allowSave = false
  //   }

  //   if (selectedUnit == null || '') {
  //     this.isScheduleValid = false
  //     this.allowSave = false
  //   }

  // }

  // validateServiceCode() {
  //   this.// = true
  //   for (let item of this.serviceCode.value) {

  //     if (
  //       (item.code != '' && item.code != null) ||
  //       item.units.length > 0
  //     ) {
  //       if (
  //         item.code == '' ||
  //         item.code == null ||
  //         item.units.length === 0
  //       ) {
  //         this.// = false
  //         break;
  //       } else {
  //         this.// = true
  //       }

  //     }


  //   }


  // }

  // getValidItem(schedules: any) {
  //   let result: Array<string> = []
  //   let isSundayValid: boolean = false

  //   if (schedules) {

  //     for (let i = 0; i < schedules.length; i++) {

  //       if (
  //         schedules[i].timetables[0]?.startTime != null &&
  //         schedules[i].timetables[0]?.endTime != null &&
  //         schedules[i].timetables[0]?.startTime != '' &&
  //         schedules[i].timetables[0]?.endTime != ''

  //       ) {
  //         if (i == 0) {
  //           isSundayValid = true
  //         } else {
  //           result.push(`${schedules[i].timetables[0].startTime} - ${schedules[i].timetables[0].endTime} (${this.getDayOfWeek(i)})`);
  //         }
  //       }
  //     }

  //   }
  //   if (isSundayValid) {
  //     result.push(`${schedules[0].timetables[0].startTime} - ${schedules[0].timetables[0].endTime} (${this.getDayOfWeek(0)})`);
  //     isSundayValid = false
  //   }

  //   return result

  // }
  // changeAddServiceCode() {
  //   if (this.form.value.flagIssueInvoice) {
  //     this.addServiceCode()
  //   } else {
  //     this.serviceCode.clear()
  //     //this.validateServiceCode()
  //   }
  // }

  // onAddNewTimeTable() {
  //   this.showEditTimeSchedule = !this.showEditTimeSchedule

  //   this.form.patchValue({
  //     scheduleRelatedUnit: null
  //   })

  //   this.resetSelectWeek()
  //   this.exceptions.clear()
  // }
  // resetSelectWeek() {

  //   this.form.controls.weekDom.reset()
  //   this.form.controls.weekSeg.reset()
  //   this.form.controls.weekTer.reset()
  //   this.form.controls.weekQua.reset()
  //   this.form.controls.weekQui.reset()
  //   this.form.controls.weekSex.reset()
  //   this.form.controls.weekSab.reset()

  //   this.form.get('weekDom')!.setValue({
  //     switch: false,
  //     weekDay: 0,
  //     periods: []
  //   })

  //   this.form.get('weekSeg')!.setValue({
  //     switch: false,
  //     weekDay: 1,
  //     periods: []
  //   })

  //   this.form.get('weekTer')!.setValue({
  //     switch: false,
  //     weekDay: 2,
  //     periods: []
  //   })

  //   this.form.get('weekQua')!.setValue({
  //     switch: false,
  //     weekDay: 3,
  //     periods: []
  //   })

  //   this.form.get('weekQui')!.setValue({
  //     switch: false,
  //     weekDay: 4,
  //     periods: []
  //   })

  //   this.form.get('weekSex')!.setValue({
  //     switch: false,
  //     weekDay: 5,
  //     periods: []
  //   })

  //   this.form.get('weekSab')!.setValue({
  //     switch: false,
  //     weekDay: 6,
  //     periods: []
  //   })

  //   this.form.patchValue({
  //     weekDom: {
  //       switch: false,
  //       weekDay: 0,
  //       periods: []
  //     },
  //     weekSeg: {
  //       switch: false,
  //       weekDay: 1,
  //       periods: []
  //     },
  //     weekTer: {
  //       switch: false,
  //       weekDay: 2,
  //       periods: []
  //     },
  //     weekQua: {
  //       switch: false,
  //       weekDay: 3,
  //       periods: []
  //     },
  //     weekQui: {
  //       switch: false,
  //       weekDay: 4,
  //       periods: []
  //     },
  //     weekSex: {
  //       switch: false,
  //       weekDay: 5,
  //       periods: []
  //     },
  //     weekSab: {
  //       switch: false,
  //       weekDay: 6,
  //       periods: []
  //     }
  //   })

  // }

  // onChangeUnit(schedule?: any) {
  //   this.// = true

  //   let selected = null

  //   if (schedule) {
  //     this.patchExamSchedule(schedule)
  //   } else {
  //     if (this.scheduleArray?.length > 0) {

  //       for (let item of this.scheduleArray) {
  //         if (item.unit == this.form.value.scheduleRelatedUnit) {
  //           selected = item;
  //           break;
  //         }
  //       }

  //       if (selected != null) {
  //         this.patchExamSchedule(selected)
  //       } else {

  //         this.exceptions.clear()
  //         this.resetSelectWeek()


  //       }

  //     } else {
  //       this.resetSelectWeek()
  //       this.exceptions.clear()

  //     }

  //   }

  //   this.// = false

  //   //this.validateSchedule()

  // }
  // editarExame(schedule: any) {
  //   this.onChangeUnit(schedule)
  //   this.showEditTimeSchedule = !this.showEditTimeSchedule
  // }

  // deletarExame(schedule: any) {
  //   let newScheduleArray = this.scheduleArray.slice()

  //   this.scheduleArray.forEach(
  //     (element: any, index) => {
  //       if (element === schedule) {
  //         newScheduleArray.splice(index, 1)
  //       }
  //     }
  //   )

  //   this.scheduleArray = newScheduleArray

  //   if (this.scheduleArray.length == 0) {
  //     this.showEditTimeSchedule = false
  //     this.resetSelectWeek()
  //     this.exceptions.clear()
  //   }
  // }
  //showEditTimeSchedule: boolean = false
  //addNewTimeSchedule: boolean = false
  //allowSave: boolean = false
  //serviceCodeValid: boolean = true
  //isChangingUnit: boolean = false
  //loadingSchedule: boolean = false
  //timeOutFn: any
  // isScheduleValid: boolean = true
  //isExceptionValid: boolean = false

  /* constructor */

  // this.form.get('weekSeg')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekTer')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekQua')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekQui')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekSex')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekSab')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  // this.form.get('weekDom')?.valueChanges.subscribe(() => {
  //   if (!this.//) {
  //     this.validateSchedule()
  //   }
  // })

  /* fim constructor */

  //validateException() {
  //this.allowSave = true

  // if (this.exceptions.value.length > 0) {
  //   for (let item of this.exceptions.value) {
  //     if (
  //       !this.exceptions.valid ||
  //       (item.startTime == '00:00' && item.endTime == '00:00') ||
  //       !this.compareTimes(item.startTime, item.endTime)
  //     ) {
  //       this.isExceptionValid = false,
  //         this.allowSubmit = false
  //       break;
  //     } else {
  //       this.isExceptionValid = true
  //       if (this.isScheduleValid) {
  //         this.allowSave = true
  //       }
  //     }
  //   }

  // }

  //}
  // onSave() {

  //   let currentExamSchedules = [this.createSchedule()]

  //   if (this.scheduleArray?.length > 0) {
  //     let newScheduleArray: Array<any> = this.scheduleArray.slice()
  //     let replace: boolean = false

  //     for (let [index, item] of this.scheduleArray.entries()) {
  //       if (item.unit == this.createSchedule().unit) {
  //         newScheduleArray[index] = this.createSchedule();
  //         replace = true
  //         break;
  //       }
  //     }

  //     if (!replace) {
  //       newScheduleArray.push(this.createSchedule())
  //     }

  //     this.scheduleArray = newScheduleArray

  //   } else {
  //     this.scheduleArray = currentExamSchedules
  //   }

  //   //currentExamSchedules = this.scheduleArray

  //   this.showEditTimeSchedule = !this.showEditTimeSchedule

  // }
}
